import React from 'react';

import { Input, Table, TableColumnsType } from 'antd';
import * as BenefitApi from '../../../../api/rank/benefitApi';

const { Search } = Input;

interface Props {
    title?: string
    dataBenefit: BenefitApi.DataTypeBenefit[]
    onSearch: (value: string) => void
    columns: TableColumnsType<BenefitApi.DataTypeBenefit > 
}

const TierBenefits: React.FC<Props> = ({ title, dataBenefit, onSearch, columns }) => {

    //   const [dataBenefit, setDataBenefit] = useState<BenefitApi.DataTypeBenefit[]>([])
    //   const [listBenefits, setListBenefits] = useState<number[]>([])

    return (
        <div className='custom-page-css w-full flex flex-col gap-2'>
            <div className="title-fz16-medium text-344054">{title || 'Quyền lợi hạng thẻ khách hàng'}</div>
            <Search placeholder="Tìm quyền lợi" onSearch={onSearch} className='custom-input-css custom-page-css' />
            <div className="t-table-block t-table-add-rank">
                <Table
                    rowClassName={(record, index) => index % 2 === 0 ? 'table-row-dark' : 'table-row-light'}
                    columns={columns}
                    dataSource={dataBenefit}
                    pagination={false}
                    showSorterTooltip={false}
                />
            </div>
        </div>
    )
}


export default TierBenefits